import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32737b00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-amap-zoom" }

import { inject, markRaw } from 'vue'
import { EventEmitter } from 'events'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-amap-zoom',
  setup(__props) {

const emitter = inject<EventEmitter>('$map-emitter')
let map:any
emitter?.once('init', (_map) => {
  map = markRaw(_map)
})
const zoomIn = () => {
  map?.zoomIn()
}
const zoomOut = () => {
  map?.zoomOut()
}

return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_icon, {
      class: "icon",
      name: "icon-plus",
      tooltip: "放大",
      onClick: zoomIn
    }),
    _createVNode(_component_app_icon, {
      class: "icon",
      name: "icon-reduce",
      tooltip: "缩小",
      onClick: zoomOut
    })
  ]))
}
}

})